import { ChartType } from '../../../types/prism';
export const V2_NAMESPACE_INDICATORS = [
    'displayVisualProps',
    'tooltipVisualProps',
    'legendVisualProps',
];
export const SUPPORTED_CHART_TYPES = [ChartType.AdvancedPivotTable];
export const CustomVisualPropsNamespaceKeys = {
    column: 'columnVisualProps',
    legend: 'legendVisualProps',
    tooltip: 'tooltipVisualProps',
    display: 'displayVisualProps',
    clientState: 'clientState',
};
export const PIVOT_NAMESPACE_CONFIG = [
    CustomVisualPropsNamespaceKeys.column,
    CustomVisualPropsNamespaceKeys.tooltip,
    CustomVisualPropsNamespaceKeys.legend,
    CustomVisualPropsNamespaceKeys.display,
    CustomVisualPropsNamespaceKeys.clientState,
];
export const FontStyles = {
    bold: 'bold',
    underline: 'underline',
    italic: 'italic',
};
export const CustomVisualPropsKeys = {
    tooltip: {
        section: 'global-tooltip',
        showTooltip: 'show-tooltip',
        backgroundColor: 'tooltip-background-color',
        selectedRowBackgroundColor: 'tooltip-selected-row-background-color',
        borderColor: 'tooltip-border-color',
        borderWidth: 'tooltip-border-width',
        backgroundOpacity: 'tooltip-opacity',
        columnNameSection: 'tooltip-column-name',
        columnNameFontColor: 'tooltip-column-name-color',
        columnNameFontSize: 'tooltip-column-name-font-size',
        columnNameFontBold: 'tooltip-column-name-font-bold',
        columnNameFontUnderline: 'tooltip-column-name-font-underline',
        columnNameFontItalic: 'tooltip-column-name-font-italic',
        columnValueSection: 'tooltip-column-value',
        columnValueFontColor: 'tooltip-column-value-color',
        columnValueFontSize: 'tooltip-column-value-font-size',
        columnValueFontBold: 'tooltip-column-value-font-bold',
        columnValueFontUnderline: 'tooltip-column-value-font-underline',
        columnValueFontItalic: 'tooltip-column-value-font-italic',
    },
    legend: {
        section: 'legend',
    },
    display: {
        section: 'display',
        totalsSummary: 'totals-summary',
        values: 'values',
        heatmapModeSection: 'heatmap-mode-section',
        pagination: 'pagination',
    },
    column: {
        section: 'column',
        columnName: 'column-name',
        columnValue: 'column-value',
    },
    clientState: {
        section: 'client-state',
    },
};
//# sourceMappingURL=constants.js.map